module.exports = __webpack_public_path__ + "8c8c7594a36cec2cd7b1629d6c8a0f23.pdf";